import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ReactDOM from "react-dom";
import Resume from "../ResumeAndDocs/Resume";
import AnchorLink from "../components/AnchorLinkComponent";
import ProjectHistory from "../ProjectHistory/ProjectHistory";
import MobilePlatform from '../Platforms/MobilePlatform';
import ServerCloudPlatform from "../Platforms/ServerCloudPlatform";
import DesktopPlatform from "../Platforms/DesktopPlatform";
import WebPlatform from "../Platforms/WebPlatform";
import EmbeddedIoTPlatform from "../Platforms/EmbeddedIoTPlatform";

class SoftwareDevelopmentService extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Software Development Services</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I can provide software development for <AnchorLink value="Mobile" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/mobile'/>, <AnchorLink value="Server/Cloud" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/servercloud'/>, <AnchorLink value="Web" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/web'/>, <AnchorLink value="Desktop" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/desktop'/> and <AnchorLink value="IoT/Embedded Systems" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/platforms/embeddediot'/>.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>With many years of experience in a broad variety of technologies I can provide solutions for your project based on the best fit rather than what I am familiar with. I will never shoe-horn your project into the solutions I am familiar with. I would always rather pass on a project than provide a less than optimal solution.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>Another advantage of my many years in the software development industry is the human and company contacts that I have made. My networking with these contacts is helpful for both additional expertise and manpower if needed and desired.</p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>For specific information about the technologies in which I have skills please refer to my <AnchorLink value="resume" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/resume'/> and for my experience please see my recent <AnchorLink value="project history" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/projecthistory'/>.</p>
                    </div>
                    <br/>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>If you have a project in distress I can help you <AnchorLink value="rescue" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/services/projectrescue'/> it.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default SoftwareDevelopmentService



// WEBPACK FOOTER //
// src/Services/SoftwareDevelopmentService.js